import { render, staticRenderFns } from "./noticebook.vue?vue&type=template&id=370d7b04&scoped=true&"
import script from "./noticebook.vue?vue&type=script&lang=js&"
export * from "./noticebook.vue?vue&type=script&lang=js&"
import style0 from "./noticebook.vue?vue&type=style&index=0&id=370d7b04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370d7b04",
  null
  
)

/* custom blocks */
import block0 from "./noticebook.vue?vue&type=custom&index=0&blockType=noscript"
if (typeof block0 === 'function') block0(component)

export default component.exports